import VisibleLoading from '@/components/utilities/VisibleLoading';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const RichTextMarkdownBlock = ({ richTextMarkdownContent: content, richTextMarkdownAnimation: animation }) => {
  return (
    <VisibleLoading delay={200} disabled={!animation}>
      {({ ref, className }) => (
        <div ref={ref} className={`my-4 ${className || ''}`.trim()}>
          <Markdown rehypePlugins={[rehypeRaw]}>{content}</Markdown>
        </div>
      )}
    </VisibleLoading>
  );
};
export default RichTextMarkdownBlock;
